import { COLOR, Icon, MessagePopup, MessagePopupsList } from '@cosuno/cosuno-ui';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { DownloadPreparationContext } from '../../DownloadPreparationContext';
import { RotatingIcon } from './DownloadPreparationMessage.styles';

export const DownloadPreparationMessage: React.FC = () => {
  const { t } = useTranslation('downloadPreparation');
  const { status } = useContext(DownloadPreparationContext);

  let defaultMessage = null;
  if (status === 'preparing') {
    defaultMessage = {
      id: 'ID',
      title: t('mainText'),
      message: t('scanningForViruses'),
      icon: <RotatingIcon type="settings-filled" />,
    };
  } else if (status === 'done') {
    defaultMessage = {
      id: 'ID',
      title: t('mainText'),
      message: t('scanningForVirusesDone'),
      icon: <Icon type="settings-filled" />,
    };
  }

  return (
    <MessagePopupsList
      transitionTime={200}
      position="top"
      messages={defaultMessage ? [defaultMessage] : []}
    >
      {(message) => (
        <MessagePopup
          data-cy-download-preparation-popup
          color={COLOR.brand}
          title={message.title}
          message={message.message}
          leftIcon={message.icon}
        />
      )}
    </MessagePopupsList>
  );
};
